// extracted by mini-css-extract-plugin
module.exports = {"detailView":"DetailLayout_detailView__356tm"};